<script>
  import privacy from '@/data/privacy-policy.js';

  export default {
    name: 'SignUpPrivacyPolicy',

    props: {
      dark: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      privacy: privacy,
    }),
  };
</script>

<template>
  <v-container class="fill-height justify-center" :class="{ dark }">
    <div class="text-subtitle-1 text-sm-h6 font-weight-800 text-center mb-3">PRIVACY POLICY</div>
    <!-- <div class="yellow-divider" /> -->
    <v-row class="justify-center text-subtitle-1 text-sm-h6 ma-2 ma-sm-6 black--text">
      <v-col cols="12">
        <div class="text-subtitle-2 text-sm-subtitle-1 font-weight-600 text-left mb-3">
          VERSION: 1.0
          <br />
          DATE OF LAST UPDATE: June 17, 2024
        </div>
        <div class="text-subtitle-1 text-sm-h6 font-weight-600 text-left">MaxQuest Statement</div>
        <div class="text-subtitle-2 text-sm-subtitle-1 text-left pp-text-border font-weight-400 py-8">
          This privacy policy (“Policy”) governs how MQ Technology DWC-LLC (operating under “MaxQuest” and
          “maxquest.com”) and its applicable affiliates and subsidiaries (collectively, “MaxQuest”, “we,” “our” or “us”)
          collect, use, protect and share personal information we collect or receive in connection with your access and
          use of:
          <br />
          <br />

          (1) MaxQuest-operated gaming websites and mobile gaming applications, including all features, functionalities,
          applications, browser extensions, and other services available through them (collectively, our United States
          “Gaming Operations”); and (2) other websites that we operate, including, without limitation, our corporate
          website, located at www.maxquest.com, and other websites or mobile applications we operate that provide a link
          directly to this Policy, including all features, functionalities, applications, browser, and extensions and
          other services available through them (collectively, our “Corporate Websites” and, together with our Gaming
          Operations, our “Online Offerings”).
          <br />
          <br />

          This Policy also applies to any personal information we collect or receive in connection with any other
          interactions we have with you outside of our Online Offerings related to our business operations, such as when
          you contact us or use other services we provide (collectively, together with our Online Offerings, our
          “Services”)., This Policy does not apply to our practices regarding the collection, use, storage, disclosure,
          and protection of personal data related to our employees and job applicants.
          <br />
          <br />

          You can access our Online Offerings in many ways, including from a computer or mobile device, and this Policy
          will apply regardless of the means of access. To the extent we provide you notice through our Online Offerings
          of different or additional privacy policies or practices (e.g., at the point of collection), those additional
          terms shall govern such data collection and use in addition to this Policy.
          <br />
          <br />

          Please read this Policy carefully. If you do not want us to collect, use, or disclose your personal
          information in the ways described in this Policy, please do not use our Services, provide us with your
          personal information, or authorize a third party to make your personal information available to us. By using
          our Services, providing us with your personal information, or otherwise making your personal information
          available to us, you acknowledge that you understand that we may use your personal information as described in
          this Policy.
          <br />
          <br />

          Please note, as described in this Policy, we may receive your personal information from third parties who have
          not expressly advised you that they will disclose your personal information to us. If you have any questions
          about how we collect, use, protect, disclose, or otherwise process personal information, including whether we
          have received your personal information from a third party, please contact us via our Live Chat feature or by
          opening a ticket on our Discord Server.
        </div>
        <div class="mt-8">
          <div class="info-panels">
            <div class="my-2" v-for="(item, index) in privacy" :key="index">
              <div class="my-2">
                <span class="text-subtitle-1 text-sm-h6 font-weight-600">{{ item.title }}</span>
              </div>
              <div>
                <p class="text-subtitle-2 text-sm-subtitle-1 font-weight-400" v-html="item.text1"></p>
                <div v-if="item.uls">
                  <ul style="list-style-type: disc; color: white" v-for="(list, index) in item.uls" :key="index">
                    <span
                      v-if="list.title"
                      class="text-subtitle-1 text-sm-h6 font-weight-400"
                      v-html="list.title"
                    ></span>
                    <span
                      v-if="list.subtitle"
                      class="text-subtitle-1 text-sm-h6 font-weight-400"
                      v-html="list.subtitle"
                    ></span>
                    <li v-for="(point, index) in list.points" :key="index">
                      <span class="text-subtitle-2 text-sm-subtitle-1 font-weight-400" v-html="point.text"></span>
                      <div v-if="point.points">
                        <ul style="list-style-type: disc">
                          <li
                            class="text-subtitle-2 text-sm-subtitle-1 font-weight-400"
                            v-for="(subpoint, index) in point.points"
                            :key="index"
                            v-html="subpoint.text"
                          ></li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>

                <div v-if="item.ols">
                  <ol :type="item.olType" style="color: white" v-for="(list, index) in item.ols" :key="index">
                    <span class="text-subtitle-1 text-sm-h6 font-weight-400" v-html="list.title"></span>
                    <span class="text-subtitle-1 text-sm-h6 font-weight-400" v-html="list.subtitle"></span>
                    <li class="mt-5" v-for="(point, index) in list.points" :key="index">
                      <span class="text-subtitle-1 text-sm-h6 font-weight-400" v-html="point.title"></span>
                      <span class="text-subtitle-2 text-sm-subtitle-1 font-weight-400" v-html="point.text"></span>
                      <span
                        class="text-subtitle-2 text-sm-subtitle-1 font-weight-400"
                        v-if="point.text1"
                        v-html="point.text1"
                      ></span>
                      <div v-if="point.ols">
                        <ol v-for="(olsPoint, index) in point.ols" :key="index">
                          <li v-for="(subOlsPoint, index) in olsPoint.points" :key="index">
                            <span
                              class="text-subtitle-2 text-sm-subtitle-1 font-weight-400"
                              v-html="subOlsPoint.text"
                            ></span>
                          </li>
                        </ol>
                      </div>
                      <span
                        class="text-subtitle-2 text-sm-subtitle-1 font-weight-400"
                        v-if="point.text2"
                        v-html="point.text2"
                      ></span>
                      <div v-if="point.uls">
                        <ul class="mt-4" v-for="(element, index) in point.uls" :key="index">
                          <li style="list-style-type: disc" :class="{ 'no-bullet': element.noBullet }">
                            <span class="text-subtitle-1 text-sm-h6 font-weight-400" v-html="element.title"></span>
                            <div v-if="element.points">
                              <ul class="mt-3 pl-5 pl-sm-10" v-for="(subpoint, index) in element.points" :key="index">
                                <li style="list-style-type: disc">
                                  <span
                                    class="text-subtitle-2 text-sm-subtitle-1 font-weight-400"
                                    v-html="subpoint.text"
                                  ></span>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <span class="text-subtitle-2 text-sm-subtitle-1" v-html="list.text1"></span>
                  </ol>
                </div>
                <p class="text-subtitle-2 text-sm-subtitle-1 font-weight-400" v-html="item.text2"></p>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">
  .container.dark {
    color: #1e1e1e !important;

    * {
      color: #1e1e1e !important;
    }
  }
  .no-bullet {
    list-style: none !important;
  }

  ol::v-deep {
    margin-bottom: 20px;

    @media screen and (max-width: 600px) {
      padding-left: 10px;
    }

    ul > ul li {
      margin-left: 5px;
    }
  }

  ul {
    margin-bottom: 10px;

    @media screen and (max-width: 600px) {
      padding-left: 10px;
    }
  }

  li {
    margin: 5px 10px 0;
  }

  li::marker {
    font-size: 20px;

    @media screen and (max-width: 600px) {
      font-size: 16px;
    }
  }
</style>
